export const environment = {
  production: true,
  apiUrl: 'https://nscpapi.herokuapp.com'
};
